import { Grid } from '@tfo/common'
import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { useHistory } from 'react-router-dom'
import IndividualHeader from '../../common/individual-header/IndividualHeader'
import ReportDetails from '../../common/report-details/ReportDetails'
import { DoneViewModel } from '../../ViewModels'

import './Done.scss'

type DoneProps = DoneViewModel

const Done: React.FunctionComponent<DoneProps &
	WrappedComponentProps> = props => {
	const {availableTo, companyName, orderId} = props
	const history = useHistory();

	return (
		<React.Fragment>
			<Grid.GridWrapper className="IndividualView Done">
				<IndividualHeader
					companyName={companyName}
					headingId="done.heading"
					preambleId="done.body"
					preambleData={{
						companyName: companyName,
					}}
				/>

				<ReportDetails
					captionId={'done.availability.caption'}
					availabilityId={'done.availability.date'}
					availabilityData={{
						date: props.intl.formatDate(availableTo)
					}}
					buttonId={'done.btn.showReport'}
					buttonIsSecondary
					onClickCallback={() => history.push(`/report/${orderId}`)}
				/>
			</Grid.GridWrapper>
		</React.Fragment>
	)
}

export default inject('rootStore')(injectIntl(observer(Done)))
